import { render, staticRenderFns } from "./MasterBidang.vue?vue&type=template&id=d7bcfae6&"
import script from "./MasterBidang.vue?vue&type=script&lang=js&"
export * from "./MasterBidang.vue?vue&type=script&lang=js&"
import style0 from "./MasterBidang.vue?vue&type=style&index=0&id=d7bcfae6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports